import { PROFILE_URL } from '@skynet/auth-feature';
import type { FeatureRouteConfig } from '@skynet/feature-config';

/**
 * Route of the user profile page, relative to the app root. The dashboard mounts
 * it as the index child of an app-owned shell route (layout, sidebar and profile
 * header stay in the app), so `load` renders into the shell's outlet; the
 * dashboard's `profile-route.test.ts` pins that wiring.
 *
 * Profile is not a `FeatureConfig`: it is the Profile domain's only page, with
 * no navigation entry, section or Cerbos navigation action.
 * `handle.skipAuthorization` lets every signed-in user open it.
 *
 * `path` is derived from `PROFILE_URL`, which `@skynet/auth-feature` owns: the
 * sign-in flows redirect there, and this package depends on auth-feature for its
 * sign-out and 2FA URLs, so the URL cannot live here without a dependency cycle.
 *
 * `load` is a dynamic-import thunk, so importing this config never pulls the page
 * implementation onto the boot path.
 */
export const profileFeatureRoute = {
  path: PROFILE_URL.replace(/^\//, ''),
  handle: { skipAuthorization: true },
  load: async () => ({ default: (await import('./UserProfile')).UserProfile }),
} as const satisfies FeatureRouteConfig;
